// src/modals/ConfirmationModal.jsx

import React, { useEffect } from 'react';
import './ConfirmationModal.css';

// Updated message library: full control for header and body separately
const messageLibrary = {
  'meet-and-greet': {
    header: "We got your request!",
    body: "We'll reach out soon to schedule your meet and greet."
  },
  'lead-submitted': {
    header: "Thanks for reaching out!",
    body: "We'll follow up soon to discuss your needs and get you started."
  },
  'booking-requested': {
    header: "Booking request received!",
    body: "We'll be in touch shortly to confirm availability."
  },
  'profile-updated': {
    header: "Profile updated!",
    body: "Your profile has been successfully updated."
  },
  // Add more types as needed
};

const ConfirmationModal = ({ onClose, type, message }) => {
  // Auto-close after 5 seconds
  useEffect(() => {
    const timer = setTimeout(() => {
      onClose();
    }, 5000);
    return () => clearTimeout(timer);
  }, [onClose]);

  let headerText = "Thank You!";
  let bodyText = "Thanks! We'll be in touch shortly.";

  if (message) {
    // If a custom one-off message is passed manually
    headerText = message.split('.')[0] + '.'; // First sentence as header
    bodyText = message.slice(headerText.length).trim(); // Remaining text as body
  } else if (messageLibrary[type]) {
    headerText = messageLibrary[type].header;
    bodyText = messageLibrary[type].body;
  }

  return (
    <div className="confirmation-modal-overlay" onClick={onClose}>
      <div
        className="confirmation-modal-container"
        onClick={(e) => e.stopPropagation()}
      >
        <button className="confirmation-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="confirmation-modal-header">{headerText}</h2>
        {bodyText && (
          <p className="confirmation-modal-message">
            {bodyText}
          </p>
        )}
        <button className="confirmation-modal-got-it" onClick={onClose}>
          Got it!
        </button>
      </div>
    </div>
  );
};

export default ConfirmationModal;
